import UpcomingClasses from '@cont/NewPreSubscribed/UpcomingClasses';
import { formatClassDetail } from '@cont/NewPreSubscribed/hooks/usePresubscribedBlocks';

const extraInfo = {
  width: '848px',
  itemsPerSlide: 3,
  lps: 'Free Classes and Tests',
  title: 'Upcoming free classes',
  description:
    'Learn with free live classes, tap on bell icon to get a notification'
};

const getFormattedClasses = (block = {}) => {
  return {
    ...block,
    courses: block?.courses?.map((classData) => formatClassDetail(classData))
  };
};
const UpcomingFeedBlock = ({ classFeedBlock, refetchEntireFeed }) => {
  const block = getFormattedClasses(classFeedBlock);
  return (
    <UpcomingClasses
      block={block}
      showUpcomingClass
      revalidateSubscribedBlocks={refetchEntireFeed}
      extraInfo={extraInfo}
    />
  );
};

export default UpcomingFeedBlock;
